<!--- Modal -->
<ui-dialog
    size="small"
    [open]="isMultiSignerStatusModalOpen"
    (closing)="isMultiSignerStatusModalOpen = false"
    header="document.menu.employeesAssigned"
>
    <app-document-multi-signer-status
        #multiSignerStatus
        (remind)="onRemindIndividual($event)"
    ></app-document-multi-signer-status>
</ui-dialog>

<ui-confirmation-dialog
    header="document.deleteDocument"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteDialog
>
    <p>
        {{
            'document.deleteAssignmentConfirmation'
                | translate: { fileName: companyDocument.name, firstName: currentAssignment?.employee?.firstName }
        }}
    </p>
</ui-confirmation-dialog>

<div class="page-container" [class.loading]="isLoading">
    <app-documents-company-document-show-header
        [companyDocument]="companyDocument"
        [backRoute]="'/documents-v2/center'"
        [showRemindButton]="true"
        (isLoading)="isLoading = $event"
        (reload)="reResolve()"
    ></app-documents-company-document-show-header>

    <ui-card [withSpacing]="false" [withMargin]="false">
        <app-table
            *ngIf="table"
            [table]="table"
            (menuItemSelected)="onMenuItemSelected($event)"
            (rowClicked)="showMultiSignerStatusModal($event)"
            [noPadding]="true"
            [embedded]="true"
            [isResponsive]="true"
            [useStickyHeader]="false"
            [showOffset]="false"
        >
            <div class="empty">
                <img src="/assets/illustrations/documents.png" />
                <h2 class="ui centered header">
                    {{ 'document.thisDocumentHasNotBeenAssignedToAnyoneYet' | translate }}
                    <ng-container
                        *ngIf="companyDocument.isSigningDocument() && !companyDocument.hasSigningTemplateConfigured()"
                        >{{ 'document.aSigningTemplateMustBe' | translate }}
                        <a
                            [routerLink]="[
                                '/documents-v2',
                                'center',
                                companyDocument.id,
                                'signingTemplate',
                                companyDocument.signingTemplate.id,
                            ]"
                            >{{ 'document.configured' | translate }}</a
                        >{{ 'document.beforeItCanBeAssigned' | translate }}</ng-container
                    >
                </h2>
            </div>
        </app-table>
    </ui-card>
</div>
